import {autoDeliveryOption} from '../../Components/DeliveryDateModal.jsx'
import {getBrowserTimeZone} from '../../Services/helpers.jsx'
import {featureNames} from '../../Services/features.jsx'
import * as domBridge from '../../Services/domBridge.jsx'

// Initial state creators
export const createInitialFormState = (
    forceUseDefaultValues,
    instantQuotePreselectedTargetLanguages,
) => {
  const languages = domBridge.getInstantQuoteLanguages()
  const subjects = domBridge.getInstantQuoteSubjects()

  const domSource =
      domBridge.getAndUpdateStoredInstantQuotePreselectedSourceLanguage(
          forceUseDefaultValues,
      )
  const domSubject = domBridge.getAndUpdateStoredInstantQuotePreselectedSubject(
      forceUseDefaultValues,
  )

  const fallbackSource = languages.find((l) => l.id === 'it-IT')
  const fallbackTarget = languages.find((l) => l.id === 'en-GB')
  const fallbackSubject = subjects.find((s) => s.id === 'general')

  return {
    sourceLanguage:
        domSource || fallbackSource || domBridge.getBrowserLanguage(),
    targetLanguages:
        instantQuotePreselectedTargetLanguages.length > 0
            ? instantQuotePreselectedTargetLanguages
            : fallbackTarget
                ? [fallbackTarget]
                : [],
    subject: domSubject || fallbackSubject,
    deliveryDate: autoDeliveryOption,
    deliveryMaxSelectableDate: undefined,
  }
}

export const createInitialQuotesState = () => ({
  posteditingQuote: undefined,
  translationQuote: undefined,
  translationRevisionQuote: undefined,
  transcreationQuote: undefined,
  laraInstantQuote: undefined,
  laraHrQuote: undefined,
  posteditingQuoteIsPending: false,
  translationQuoteIsPending: false,
  translationRevisionQuoteIsPending: false,
  transcreationQuoteIsPending: false,
  laraInstantQuoteIsPending: false,
})

export const createInitialUIState = () => ({
  isFormSubmitted: false,
  isFormChanged: false,
  showQuotes: false,
  isDeliveryDateModalVisible: false,
  translatorsCount: undefined,
})

export const createInitialConfigState = () => ({
  currency: 'EUR',
  rates: {EUR: 1},
  selectedTimeZone: getBrowserTimeZone(),
  firstCardSolution: featureNames.PREMIUM,
  secondCardSolution: featureNames.PROFESSIONAL,
  thirdCardSolution: featureNames.ECONOMY,
})

// Form reducer
export const formReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SOURCE_LANGUAGE':
      return {...state, sourceLanguage: action.payload}
    case 'SET_TARGET_LANGUAGES':
      return {...state, targetLanguages: action.payload}
    case 'SET_SUBJECT':
      return {...state, subject: action.payload}
    case 'SET_DELIVERY_DATE':
      return {...state, deliveryDate: action.payload}
    case 'SET_DELIVERY_MAX_DATE':
      return {...state, deliveryMaxSelectableDate: action.payload}
    default:
      return state
  }
}

// Quotes reducer
export const quotesReducer = (state, action) => {
  switch (action.type) {
    case 'SET_POSTEDITING_QUOTE':
      return {...state, posteditingQuote: action.payload}
    case 'SET_TRANSLATION_QUOTE':
      return {...state, translationQuote: action.payload}
    case 'SET_TRANSLATION_REVISION_QUOTE':
      return {...state, translationRevisionQuote: action.payload}
    case 'SET_TRANSCREATION_QUOTE':
      return {...state, transcreationQuote: action.payload}
    case 'SET_LARA_INSTANT_QUOTE':
      return {...state, laraInstantQuote: action.payload}
    case 'SET_LARA_HR_QUOTE':
      return {...state, laraHrQuote: action.payload}
    case 'SET_ALL_QUOTES_PENDING':
      return {
        ...state,
        posteditingQuoteIsPending: true,
        translationQuoteIsPending: true,
        translationRevisionQuoteIsPending: true,
        transcreationQuoteIsPending: true,
        laraInstantQuoteIsPending: true,
      }
    case 'SET_ALL_QUOTES_LOADED':
      return {
        ...state,
        posteditingQuoteIsPending: false,
        translationQuoteIsPending: false,
        translationRevisionQuoteIsPending: false,
        transcreationQuoteIsPending: false,
        laraInstantQuoteIsPending: false,
      }
    case 'SET_QUOTES':
      return {
        ...state,
        ...action.payload,
        posteditingQuoteIsPending: false,
        translationQuoteIsPending: false,
        translationRevisionQuoteIsPending: false,
        transcreationQuoteIsPending: false,
        laraInstantQuoteIsPending: false,
      }
    case 'RESET_QUOTES':
      return {
        ...state,
        posteditingQuote: undefined,
        translationQuote: undefined,
        translationRevisionQuote: undefined,
        transcreationQuote: undefined,
        laraInstantQuote: undefined,
      }
    default:
      return state
  }
}

// UI reducer
export const uiReducer = (state, action) => {
  switch (action.type) {
    case 'SET_FORM_SUBMITTED':
      return {...state, isFormSubmitted: action.payload}
    case 'SET_FORM_CHANGED':
      return {...state, isFormChanged: action.payload}
    case 'SET_SHOW_QUOTES':
      return {...state, showQuotes: action.payload}
    case 'SET_DELIVERY_DATE_MODAL_VISIBLE':
      return {...state, isDeliveryDateModalVisible: action.payload}
    case 'SET_TRANSLATORS_COUNT':
      return {...state, translatorsCount: action.payload}
    default:
      return state
  }
}

// Config reducer
export const configReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CURRENCY':
      return {...state, currency: action.payload}
    case 'SET_RATES':
      return {...state, rates: action.payload}
    case 'SET_TIMEZONE':
      return {...state, selectedTimeZone: action.payload}
    case 'SET_SOLUTIONS':
      return {
        ...state,
        firstCardSolution: action.payload.first,
        secondCardSolution: action.payload.second,
        thirdCardSolution: action.payload.third,
      }
    default:
      return state
  }
}
